import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'
import {ICustomTextPayload} from '../../SERVICE-INTERFACES'

const survey_endpoints = APIS_ENDPOINTS.customText

export const request_create = async ({Text, Title, Id}: ICustomTextPayload) => {
  const formData = new FormData()
  formData.append('Id', Id?.toString() || '')
  formData.append('Title', Title)
  formData.append('Text', Text) 

  return http.post(survey_endpoints.create, formData)
}
export const request_edit = async ({Text, Title, Id}: ICustomTextPayload) => {
  const formData = new FormData()
  formData.append('Id', Id?.toString() || '')
  formData.append('Title', Title)
  formData.append('Text', Text) 

  return http.put(survey_endpoints.edit, formData)
}

export const request_getAll = async ({
  search,
  CurrentPage,
  PageSize,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
}) => {
  return http.get(
    survey_endpoints.getlist +
      `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}`
  )
}

export const request_delete = async (id: number) => {
  return http.delete(survey_endpoints.delete + `?Id=${id}`)
}

export const request_unactive = async (id: number) => {
  return http.delete(survey_endpoints.unactive + `?Id=${id}`)
}

export const request_active = async (id: number) => {
  return http.put(survey_endpoints.active + `?Id=${id}`)
}


export const request_getAllData = async () => {
  return http.get(survey_endpoints.getAll)
}
